<script>
import { getCountryCallingCode, getCountries } from 'libphonenumber-js';
import { BModal, BButton } from 'bootstrap-vue';
import InputPhoneNumber from '../input/PhoneNumber.vue';
import Swal from 'sweetalert2';

export default {
  components: {
    BModal,
    BButton,
    InputPhoneNumber
  },

  mounted() {
    this.getFields();
    this.getUsers();
    this.getOrigins();

    window.addEventListener('beforeunload', this.handleBeforeUnloadBrowser);

    Bus.$on('createLeadButtonToggled', () => {
      this.getFields();
      this.open();
    });

    Bus.$on('editLeadButtonToggled', (lead) => {
      this.open(lead);
    });

    Bus.$on('createOrUpdateOrigin', () => this.getOrigins());

    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (event.trigger == 'update' && modalId == 'modal-new-lead') {
        Bus.$emit('addLeadOwnerButtonTrigger', this.lead);
      }
    });

    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (modalId === 'modal-new-lead' && this.hasUnsavedChanges) {
        event.preventDefault();
        this.handleBeforeUnload(() => {
          this.$refs['modal-new-lead'].hide();
        });
      }
    });
  },

  store: ['users'],

  data() {
    return {
      lead: {
        hashid: '',
        email: '',
        owner: '',
        origin: '',
        phone: ''
      },
      phoneCountry: '55',
      placeholder: '',
      phoneErrorMessage: false,
      errors: [],
      fields: [],
      origins: [],
      custom: true,
      saving: false,
      loading: true,
      hasUnsavedChanges: false,
      initialLead: null,
      loading: true,
      isLoading: true
    };
  },

  watch: {
    isLoading(newValue) {
      if (!newValue) {
        this.$nextTick(() => {
          this.initialLead = JSON.stringify(this.getComparableLead(this.lead));
        });
      }
    },
  },

  computed: {
    modalSize() {
      return this.custom && this.fields.length > 6 ? 'lg' : 'sm';
    },

    columnsClass() {
      return this.custom && this.fields.length > 6 ? 'col-md-6' : 'col-md-12';
    },

    generalFields() {
      return this.fields.filter(
        (field) =>
          !(!this.custom && field.type === 'custom') &&
          field.hidden_when_creating === Boolean(this.hashid) &&
          field.field_type !== 'checkbox',
      );
    },

    checkboxFields() {
      return this.fields.filter(
        (field) =>
          !(!this.custom && field.type === 'custom') &&
          field.hidden_when_creating === Boolean(this.hashid) &&
          field.field_type === 'checkbox',
      );
    },

    onwerSelectDefaultValue() {
      return (this.lead && this.lead.owner) ? this.lead.owner : '';
    },

    originSelectDefaultValue() {
      return (this.lead && this.lead.origin) ? this.lead.origin : '';
    }
  },

  methods: {
    handleBeforeUnloadBrowser(event) {
      if (this.hasUnsavedChanges) {
        event.preventDefault();
        event.returnValue = '';
      }
    },

    beforeDestroy() {
      window.removeEventListener('beforeunload', this.handleBeforeUnloadBrowser);
    },

    onModalHide(event) {
      if (this.hasUnsavedChanges) {
        event.preventDefault();
        this.handleBeforeUnload(() => {
          this.$refs['modal-new-lead'].hide();
        });
      }
    },

    handleBeforeUnload(callback) {
      if (this.hasUnsavedChanges) {
        Swal.fire({
          iconHtml: '<img src="/build/icons/question-circle.svg" style="width: 72px; height: 72px;">',
          title: this.__('Deseja realmente sair?'),
          html: `
            <div class="container-basic mb-3">
              <span class="container-basic-title">${this.__('Existem alterações que não foram salvas.')}</span>
            </div>
          `,
          buttonsStyling: false,
          allowOutsideClick: false,
          confirmButtonText: this.__('Sair'),
          cancelButtonColor: 'transparent',
          cancelButtonText: this.__('Cancelar'),
          showCancelButton: true,
          customClass: {
            container: 'container-delete-lead',
            confirmButton: 'salesflow-btn salesflow-btn-secondary',
            cancelButton: 'btn swal2-btn-cancel-transparent swal2-btn-full-line',
            icon: 'no-border'
          }
        }).then((result) => {
          if (result.isConfirmed) {
            this.hasUnsavedChanges = false;
            if (callback) callback();
          }
        });
      } else if (callback) {
        callback();
      }
    },

    normalizeValue(value) {
      return value === "" || value === undefined ? null : value;
    },

    handleInputChange() {
      clearTimeout(this.inputChangeTimeout);

      this.inputChangeTimeout = setTimeout(() => {
        const currentLead = JSON.stringify(this.getComparableLead(this.lead));
        this.hasUnsavedChanges = currentLead !== this.initialLead;
      }, 0);
    },

    getComparableLead(lead) {
      const relevantFields = this.fields.map(field => field.identifier);
      const fixedFields = ['email', 'owner', 'origin', 'phone'];
      const allFields = [...new Set([...relevantFields, ...fixedFields])];

      return allFields.sort().reduce((acc, key) => {
        let value = this.normalizeValue(lead[key]);
        if (key === 'phone' && value) {
          value = this.formatPhoneNumber(value);
        }

        acc[key] = value;
        return acc;
      }, {});
    },

    formatPhoneNumber(phone) {
      if (!phone) return "";
      return phone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    },

    open(lead = {}) {
      this.lead = JSON.parse(JSON.stringify(lead));
      this.isLoading = true;
      this.resetPhoneInput();

      if (lead.hashid) {
        this.getLead(lead);
      } else {
        this.isLoading = false;
      }

      this.$nextTick(() => {
        if (this.lead.phone) {
          const phonePattern = /^\(\d{2}\) \d{4,5}-\d{4}$/;
          if (!phonePattern.test(this.lead.phone)) {
            this.lead.phone = this.formatPhoneNumber(this.lead.phone);
          }
        }
        this.initialLead = JSON.stringify(this.getComparableLead(this.lead));
      });

      this.$refs['modal-new-lead'].show();
    },

    getUsers() {
      this.$http
        .get('/user/json')
        .then((response) => {
          this.users = response.data;
        })
        .catch(() => {
          /**
           * Set empty array
           * To prevent break in others components
           */
          this.users = [];
        });
    },

    getFields() {
      this.$http
        .get('/settings/field')
        .then(({ data }) => {
          const fields = data.filter((field) => !field.hidden);

          Bus.$emit('fieldsRetrieved', fields);

          this.fields = fields;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getOrigins() {
      this.$http.get('/settings/origin').then(({ data }) => {
        this.origins = data.filter((field) => !field.hidden);
      });
    },

    toggleFields() {
      this.custom = !this.custom;
    },

    getLead(lead) {
      this.loading = true;
      this.isLoading = true;

      this.$http
        .get(`/lead/${lead.hashid}/json`)
        .then((response) => {
          this.lead = response.data;
          const valid_phone = this.lead.valid_phone;
          if (valid_phone && valid_phone.length) {
            this.processPhoneNumber(valid_phone);
          }
          this.lead.origin = response.data.origin?.name || null;
          this.setCheckboxValues(response.data.field_values);
        })
        .finally(() => {
          this.loading = false;
          this.isLoading = false;
        });
    },


    processPhoneNumber(phoneNumber) {
      const countries = getCountries();
      let foundCountry = null;
      for(let i = 1; i <= 3 && !foundCountry; i++) {
        for (const country of countries) {
          if (getCountryCallingCode(country) === phoneNumber.slice(0, i)) {
            foundCountry = country
            break
          }
        }
      }

      if (foundCountry) {
        const DDI = getCountryCallingCode(foundCountry)
        this.phoneCountry = DDI
        this.lead.phone = phoneNumber.slice(DDI.length)
      }
    },

    save() {
      this.errors = [];
      this.saving = true;

      if (!this.validatePhone(this.phoneCountry, this.lead.phone)) {
        this.errors = {
          phone: [this.__('Telefone inválido')]
        };
        this.saving = false;
        return;
      }

      if (this.lead.hashid) {
        this.update();
      } else {
        this.create();
      }

      this.hasUnsavedChanges = false;
    },

    create() {
      this.$http
        .post('/lead', {
          ...this.lead,
          'phone': this.lead.phone ? `${this.phoneCountry}${this.lead.phone}` : ''
        })
        .then((response) => {
          Bus.$emit('leadAdded', response.data);

          window.location = `/lead/${response.data.hashid}`;
        })
        .catch((response) => {
          this.errors = response.data;
          this.saving = false;
        });
    },

    update() {
    this.$http
      .put(`/lead/${this.lead.hashid}`, {
        ...this.lead,
        phone: this.lead.phone ? `${this.phoneCountry}${this.lead.phone}` : ''
      })
      .then((response) => {
        Bus.$emit('leadUpdated', response.data);
        window.location.reload();
      })
      .catch(({ data }) => {
        console.log(data);

        this.saving = false;

        if (data.lead && data.lead.hashid) {
          this.lead = data.lead;
          this.$refs['modal-new-lead'].hide('update');
          return;
        }

        if (data.email || data.phone || data.document) {
          const [pk] = Object.keys(data);
          const errorMessage = data[pk][0];

          if (data.phone && data.phone.message) {
            const messageWithoutLink = data.phone.message;
            const errorMessage = `${data.phone.message} <a href="${data.phone.hashid}" target="_blank" class="highlight-link text-danger">Ver aqui</a>`;
            data.phone[0] = errorMessage;
            Alert.error(messageWithoutLink);
          } else if (data.email && data.email.message) {
            const messageWithoutLink = data.email.message;
            const errorMessage = `${data.email.message} <a href="${data.email.hashid}" target="_blank" class="highlight-link text-danger">Ver aqui</a>`;
            data.email[0] = errorMessage;
            Alert.error(messageWithoutLink);
          } else if (data.document && data.document.message) {
            const messageWithoutLink = data.document.message;
            const errorMessage = `${data.document.message} <a href="${data.document.hashid}" target="_blank" class="highlight-link text-danger">Ver aqui</a>`;
            data.document[0] = errorMessage;
            Alert.error(messageWithoutLink);
          } else {
            Alert.error(this.__(errorMessage));
          }
        } else {
          Alert.error(this.__('Erro ao atualizar, tente novamente em instantes.'));
        }

        this.errors = data;
        window.scrollTo(0, 0);
      });
    },

    prepare(type, field) {
      if (type != field.field_type) {
        return false;
      }

      if (type == 'checkbox' && !this.lead[field.identifier]) {
        this.lead[field.identifier] = [];
      }

      return true;
    },

    setCheckboxValues(checkboxes) {
      checkboxes.forEach((checkbox) => {
        const fieldIdentifier = checkbox.field.identifier;
        const fieldType = checkbox.field.field_type;
        const fieldValue = checkbox.value;
        const fieldDecodedValue = checkbox.decoded_value;

        if(fieldType === 'checkbox') {
          this.lead[fieldIdentifier] = fieldDecodedValue;
        } else {
          this.lead[fieldIdentifier] = fieldValue;
        }
      })
    },

    validatePhone(DDI, phone) {
      // deixar com que o back valide caso o input de telefone esteja vazio.
      if(!phone) return true;
      const letterRegex = /[a-zA-Z]/;
      let fullPhone = `${DDI}${phone}`
      if(letterRegex.test(fullPhone)) return false;
      fullPhone = fullPhone.replace(/[\s()-]/g, '')

      if(fullPhone.length <= 3) return false
      const isBrazilianDDI = DDI == '55'
      if(DDI.length === 2 && isBrazilianDDI) {
        if(fullPhone.length < 12 || fullPhone.length > 13) return false;
      }
      return true;
    },

    handleCountry(data) {
      this.phoneCountry = data.dialCode
      this.placeholder = data.iso2 === 'BR' ? '(00) 12345-6789' : ''
    },

    resetPhoneInput() {
      this.phoneCountry = '55'
      this.errors = {
        phone: ''
      }
    }
  },
};
</script>

<template>
  <BModal
    :size="modalSize"
    id="modal-new-lead"
    ref="modal-new-lead"
    hide-footer="hide-footer"
    @hide="onModalHide"
  >
    <template slot="modal-header">
      <div class="modal-title" v-if="lead.hashid" v-text="__('Editar Lead')" />

      <div v-else class="modal-title" v-text="__('Novo Lead')" />

      <a
        href="#"
        style="display: none"
        class="btn btn-sm float-right"
        @click.prevent="toggleFields()"
      >
        <span v-if="custom" v-text="__('Esconder')" />

        <span v-else v-text="__('Exibir')" />

        {{ __('campos customizados') }}
      </a>

      <button
        class="close"
        type="button"
        aria-label="Close"
        data-dismiss="modal"
        @click="$refs['modal-new-lead'].hide()"
      >
        <span aria-hidden="true">
          <img
            width="14"
            height="13"
            alt="Fechar"
            class="mb-1"
            src="/build/icons/close@white.svg"
          />
        </span>
      </button>
    </template>

    <template slot="default">
      <form class="bdk-pt-5 bdk-px-1" method="post" @submit.prevent="save()">
        <div class="inputs-container bdk-max-h-[480px] bdk-overflow-x-hidden bdk-px-5">
          <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin" />
          </div>

          <div v-else>
            <div class="row" v-if="errors['form']">
              <div class="col-md-12 text-center">
                <p v-html="errors['form']" class="form-text text-danger" />
              </div>
            </div>

            <div class="row">
              <div
                :class="columnsClass"
                :key="field.identifier"
                v-for="field in generalFields"
              >
                <div class="form-group">
                  <label
                    v-text="__(field.description) + (field.primary_key ? ' (' + __('Chave primária') + ')' : '')"
                  />

                  <input
                    :id="field.identifier"
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    :class="{'error-input': errors[field.identifier]}"
                    v-if="prepare('text', field) && field.identifier !== 'phone' && field.identifier !== 'email'"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                  />
                  <div v-if="field.identifier === 'phone'" :class="{'error-input': errors.phone}">
                    <InputPhoneNumber
                      :value="lead[field.identifier]"
                      :placeholder="placeholder"
                      :default-country="phoneCountry"
                      @country-changed="(data) => handleCountry(data)"
                      @input="(data) => {
                        lead[field.identifier] = data.number;
                        handleInputChange();
                      }"
                    />
                  </div>
                  <input
                    :id="field.identifier"
                    type="email"
                    autocomplete="off"
                    class="form-control"
                    :class="{'error-input': errors[field.identifier]}"
                    v-if="prepare('email', field) || field.identifier === 'email'"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                  />

                  <textarea
                    :id="field.identifier"
                    class="form-control"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                    v-else-if="prepare('textarea', field)"
                  />

                  <select
                    :id="field.identifier"
                    class="form-control"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                    v-else-if="prepare('select', field)"
                  >
                    <option value="" v-text="__('Selecione')" />

                    <option
                      :id="option.value"
                      :key="option.value"
                      :value="option.value"
                      v-text="option.value"
                      v-for="option in field.options"
                    />
                  </select>

                  <div
                    class="form-check"
                    :key="'checkbox-'+ option.value"
                    v-for="option in field.options"
                    v-else-if="prepare('checkbox', field)"
                  >
                    <label class="form-check-label" :for="option.value">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :id="option.value"
                        :value="option.value"
                        v-model="lead[field.identifier]"
                        @input="handleInputChange"
                      />

                      {{ option.value }}
                    </label>
                  </div>

                  <div
                    class="form-radio"
                    :key="'radio' + option.value"
                    v-else-if="prepare('radio', field)"
                    v-for="option in field.options"
                  >
                    <input
                      type="radio"
                      :value="option.value"
                      class="form-check-input"
                      v-model="lead[field.identifier]"
                      :id="option.value"
                      @input="handleInputChange"
                    />
                    <label
                      class="input-radio-label"
                      :for="option.value"
                    >{{ option.value }}</label>
                  </div>

                  <input
                    :id="field.identifier"
                    type="text"
                    autocomplete="off"
                    class="form-control"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                    v-else-if="prepare('date', field)"
                  />

                  <input
                    :id="field.identifier"
                    class="form-control"
                    type="text"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                    v-else-if="prepare('time', field)"
                    autocomplete="off"
                  />

                  <input
                    :id="field.identifier"
                    class="form-control"
                    type="text"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                    v-else-if="prepare('datetime', field)"
                    autocomplete="off"
                  />

                  <input
                    :id="field.identifier"
                    class="form-control"
                    type="number"
                    v-model="lead[field.identifier]"
                    @input="handleInputChange"
                    :class="{'error-input': errors[field.identifier]}"
                    v-else-if="prepare('number', field)"
                    autocomplete="off"
                  />
                  <p
                    class="form-text text-danger"
                    v-if="['phone', 'email', 'document'].includes(field.identifier) && errors[field.identifier]"
                    v-html="errors[field.identifier][0]"
                  ></p>
                  <p
                    class="form-text text-danger"
                    v-else-if="errors[field.identifier]"
                    v-text="errors[field.identifier][0]"
                  ></p>
                </div>
              </div>
              <div :class="columnsClass" v-if="origins.length">
                <div class="form-group">
                  <label v-text="__('Origem')" />

                  <select class="form-control" v-model="lead.origin" id="origin" @input="handleInputChange">
                    <option value="" disabled="" v-text="__('Selecione')" />

                    <option
                      :id="origin.name"
                      :key="origin.id"
                      :value="origin.name"
                      v-text="origin.name"
                      v-for="origin in origins"
                    />
                  </select>
                </div>
              </div>

              <template v-if="!lead.hashid">
                <div :class="columnsClass" v-if="users.length">
                  <div class="form-group">
                    <label v-text="__('Dono')" />

                    <select class="form-control" v-model="lead.owner" id="owner">
                      <option value="" disabled="" v-text="__('Selecione')" />

                      <option
                        :id="user.id"
                        :key="user.id"
                        :value="user.id"
                        v-for="user in users"
                      >
                        {{ user.first_name }} ({{ user.email }})
                      </option>
                    </select>
                  </div>
                </div>
              </template>
            </div>

            <div class="bdk-flex bdk-flex-col">
              <div
                class="form-group"
                :key="field.identifier"
                v-for="field in checkboxFields"
              >
                <template v-if="field.options">
                  <label v-text="__(field.description)" />

                  <div
                    class="form-checkbox"
                    :key="option.value"
                    v-for="option in field.options"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="option.value"
                      :value="option.value"
                      v-model="lead[field.identifier]"
                    />
                    <label
                      :for="option.value"
                      class="input-checkbox-label"
                      v-if="prepare('checkbox', field)"
                    >
                    {{ option.value }}
                    </label>
                  </div>
                </template>
                <template v-else>
                  <div class="form-checkbox">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="field.identifier"
                      :value="lead[field.identifier]"
                      v-model="lead[field.identifier]"
                    />
                    <label
                      class="input-checkbox-label"
                      :for="field.identifier"
                    > {{ __(field.description) }}
                    </label>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div v-if="!loading" class="row bdk-mt-5">
          <div class="col-md-12 text-center">
            <BButton id="save-button" type="submit" variant="primary" :disabled="saving">
              <span v-if="saving">
                <i class="fa fa-circle-o-notch fa-spin" />

                {{ __('Salvando...') }}
              </span>

              <span v-else v-text="__('Salvar')" />
            </BButton>
          </div>
        </div>
      </form>
    </template>
  </BModal>
</template>

<style lang="scss">
@import '../../../sass/variables';
@import '../../../sass/mixins';

#save-button {
  background-color: $salesflow-secondary;
  border-radius: 14px;
  padding: 12px 32px;

  &:hover {
    background-color: $salesflow-secondary-hover;
  }
}

#modal-new-lead {
  .modal-dialog {
    border-radius: 16px;
    overflow: hidden;
  }

  .modal-dialog.modal-sm {
    width: 631px;
  }

  .modal-dialog.modal-lg {
    width: 631px;
  }

  .modal-header {
    background-color: $salesflow-primary;
        height: 50px;
        display: flex;
        align-items: center;
        padding: 16px 24px;

        .modal-title {
          font-size: 12px;
          font-weight: 400;
        }
  }

  .modal-body {
    padding: 0px 0px 32px;
    background-color: $salesflow-bg-content !important;


    form {
      color: $salesflow-font-dark;

      .inputs-container {
        &::-webkit-scrollbar {
          width: 8px;
        }

        &::-webkit-scrollbar-track {
          background-color: transparent;
        }

        &::-webkit-scrollbar-thumb {
          background-color: $salesflow-primary;
          border-radius: 8px;
        }
      }

      label {
        font-size: 0.75rem;
        line-height: 150%;
        font-weight: 500;
        margin-bottom: 6px;
      }

      input, select {
        background-color: $white;
        outline: 1px solid $salesflow-outline-gray-medium;
        border-radius: 8px;
        padding: 14px 12px;
      }

      input {
        font-size: 1rem;
      }

      input[type="checkbox"],
      input[type='radio'] {
        outline: none;
        position: relative;
        margin: 0;
      }

      select {
        font-size: 0.75rem;
        font-weight: 500;
      }
    }

    .form-checkbox,
    .form-radio {
      display: flex !important;
      align-items: center !important;
      margin-left: 0 !important;
      gap: 4px !important;
      margin-bottom: 6px !important;
    }

    .form-checkbox:last-child,
    .form-radio:last-child {
      margin-bottom: 0 !important;
    }

    .input-checkbox-label,
    .input-radio-label {
      font-size: 0.75rem !important;
      line-height: 150% !important;
      font-weight: 500 !important;
      margin-bottom: 1px !important;
    }
  }

  .error-input {
    border: 1px solid red !important;
    border-radius: 10px;
    outline: none;
  }
  .highlight-link {
    text-decoration: underline !important;
    font-weight: 600;
  }

  .vti__input {
    border-radius: 0 8px 8px 0 !important;
  }

  .vti__input:focus {
    border: none;
  }

  .vti__dropdown {
    outline: 1px solid #d1d1d1;
    border-radius: 8px 0 0 8px;
  }

  .vti__dropdown-list {
    height: 140px;
    margin-top: 10px;
  }
}
</style>
